const ConnectingStatus = {
  ONE_SIDE: "一方",
  TWO_SIDE: "二方",
  THREE_SIDE: "三方",
  FOUR_SIDE: "四方",
  CONNER: "角地",
  NO_SIDE: "接道なし",
} as const;

export type IConnectingStatus = typeof ConnectingStatus[keyof typeof ConnectingStatus];

export const connectingStatusOptions = Object.values(ConnectingStatus).map(value => ({ label: value, value }));

export const switchConnectingRoadStatusNumber = (status: IConnectingStatus) => {
  switch (status) {
    case ConnectingStatus.ONE_SIDE:
      return 1;
    case ConnectingStatus.TWO_SIDE:
    case ConnectingStatus.CONNER:
      return 2;
    case ConnectingStatus.THREE_SIDE:
      return 3;
    case ConnectingStatus.FOUR_SIDE:
      return 4;
    default:
      return 0;
  }
};

export default ConnectingStatus;
